export const ICON_CONVERT_VIRTUAL_DEVICE = ['cm-virtualdevice', 'cm-input-output']
export const ICON_CONVERT_TAPPARELLA = ['cm-tapparella', 'cm-device-tapparella']
export const ICON_CONVERT_LOCK = ['cm-allarme', 'cm-lock']
export const ICON_CONVERT_SOUND = ['cm-audio', 'cm-sound']
export const ICON_CONVERT_CAMERA = ['cm-cameratvcc', 'cm-camera']
export const ICON_CONVERT_LOAD = ['cm-carichi', 'cm-load']
export const ICON_CONVERT_LOAD_2 = ['cm-carichi2', 'cm-load']

export const ICON_CONVERT_AUTOMATICDOOR = ['cm-device-automaticdoor-1', 'cm-device-automaticdoor']
export const ICON_CONVERT_BARRIER = ['cm-device-barrier-0', 'cm-device-barrier']
export const ICON_CONVERT_SLIDINGGATE = ['cm-device-slidinggate-0', 'cm-device-slidinggate']
export const ICON_CONVERT_SWINGGATE = ['cm-device-swinggate-1', 'cm-device-swinggate']
export const ICON_CONVERT_GARAGE = ['cm-device-shutter-0', 'cm-device-garage']
export const ICON_CONVERT_TURNSTILE = ['cm-device-turnstile-1', 'cm-device-turnstile']
